import { render, staticRenderFns } from "./DxPrescriptionManager.vue?vue&type=template&id=20ea554c&"
import script from "./DxPrescriptionManager.vue?vue&type=script&lang=js&"
export * from "./DxPrescriptionManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports